/**
 * Extracts the first few words from lyrics to use as a title fallback
 * @param lyrics - The lyrics text
 * @param maxWords - Maximum number of words to extract (default: 3)
 * @param appendVersion - Optional version suffix to append (e.g., "Version 1")
 * @returns The extracted title or empty string if no lyrics
 */
export const extractTitleFromLyrics = (
  lyrics: string | undefined | null,
  maxWords: number = 3,
  appendVersion?: string,
): string => {
  if (!lyrics || typeof lyrics !== 'string') {
    return '';
  }

  // Remove brackets (like [Verse 1], [Chorus], etc.) and markdown formatting
  let cleaned = lyrics.replace(/\[.*?\]/g, '').trim();
  
  // Remove markdown: **bold**, *italic*, __underline__, _italic_, ~~strikethrough~~
  cleaned = cleaned.replace(/(\*\*|__)(.*?)\1/g, '$2');
  cleaned = cleaned.replace(/(\*|_)(.*?)\1/g, '$2');
  cleaned = cleaned.replace(/~~(.*?)~~/g, '$1');

  // Split by whitespace and filter out empty strings
  const words = cleaned.split(/\s+/).filter((word) => word.length > 0);

  if (words.length === 0) {
    return '';
  }

  // Take first maxWords words
  const titleWords = words.slice(0, maxWords);

  // Join and capitalize first letter
  const title = titleWords.join(' ');
  const capitalized = title.charAt(0).toUpperCase() + title.slice(1);

  // Add ellipsis and append version if provided
  if (appendVersion) {
    return `${capitalized}... (${appendVersion})`;
  }
  return capitalized;
};
